import { Question } from '@/api/api.schemas';
import { useField } from '../form';
import { TextInput } from './text-input';
import { Checkbox } from './checkbox';
import styles from './date-with-option.module.css';

interface DatePastWithOptionRendererProps {
  question: Question;
  name: string;
  className?: string;
}

export function DatePastWithOptionRenderer({
  question,
  name,
  className,
}: DatePastWithOptionRendererProps) {
  const { getValue, setValue } = useField<string>(name, undefined);

  const handleOptionChange = (checked: boolean, answerId: string) => {
    if (checked) {
      setValue(answerId);
      return;
    }

    setValue('');
  };

  return (
    <div className={className}>
      <TextInput
        name={name}
        label={question.text}
        subLabel={question.subText}
        placeholder={question.placeholderText ?? undefined}
        type="date"
        withIconsIndicators={false}
      />
      {question.answers.map((answer) => (
        <Checkbox
          key={answer.answerId}
          className={styles.dateOption}
          name={`${name}-option`}
          label={answer.text}
          checked={getValue() === answer.answerId.toString()}
          onChange={(event) => handleOptionChange(event.target.checked, answer.answerId.toString())}
        />
      ))}
    </div>
  );
}
